(() => {
  'use strict';
  const initialize = () => document.querySelectorAll('[data-editorial-page]').forEach(root => {
    if (root.dataset.editorialReady) return;
    root.dataset.editorialReady = 'true';
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const sync = () => {
      const variant = variants.find(item => String(item.id) === root.querySelector('[name="id"]').value);
      if (!variant) return;
      root.querySelector('.syk-main-product-image').sizes = '(min-width: 1440px) 724px, (min-width: 990px) 52vw, (min-width: 750px) 48vw, 310px';
      document.querySelectorAll('[data-editorial-selection]').forEach(node => { node.textContent = variant.title; });
      document.querySelectorAll('[data-editorial-price]').forEach(node => { node.textContent = variant.price; });
      document.querySelectorAll('.syk-catalog-depth [data-variant-included]').forEach(node => { node.textContent = variant.included; });
    };
    root.querySelector('form').addEventListener('change', sync);
    sync();
    const mergeReviewSchema = () => {
      const native = document.querySelector('[data-syk-product-schema]');
      const reviewScript = document.querySelector('script.jdgm-aggregate-rating-jld');
      if (!native || !reviewScript) return false;
      try {
        const schema = JSON.parse(native.textContent), review = JSON.parse(reviewScript.textContent);
        if (new URL(review['@id']).pathname !== new URL(schema.url).pathname) return false;
        const rating = Number(review.aggregateRating?.ratingValue), count = Number(review.aggregateRating?.reviewCount);
        if (!(rating >= 1 && rating <= 5 && Number.isInteger(count) && count > 0)) return false;
        schema.aggregateRating = {'@type': 'AggregateRating', ratingValue: rating, reviewCount: count, bestRating: 5, worstRating: 1};
        native.textContent = JSON.stringify(schema); reviewScript.remove(); return true;
      } catch { return false; }
    };
    if (!mergeReviewSchema()) {
      const observer = new MutationObserver(() => { if (mergeReviewSchema()) observer.disconnect(); });
      observer.observe(document.documentElement, {childList: true, subtree: true});
    }
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
